import React from 'react';
import { Card, Badge } from '@/components/ui';
import type { ProgressPhoto } from '../types/construction-progress.types';

interface Props {
  photos: ProgressPhoto[];
  isLoading?: boolean;
}

export const ProgressPhotoGallery: React.FC<Props> = ({ photos, isLoading }) => {
  if (isLoading) return <div className="p-12 text-center text-slate-400">Đang tải hình ảnh...</div>;
  if (photos.length === 0) return <div className="p-12 text-center text-slate-400">Không có hình ảnh đính kèm</div>;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {photos.map((photo) => (
        <Card key={photo.id} className="group overflow-hidden border-slate-100 shadow-sm hover:shadow-md transition-all">
          <div className="aspect-square relative overflow-hidden bg-slate-50">
            <img 
              src={photo.file_path} 
              alt={photo.caption || 'Progress photo'} 
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute top-2 left-2">
              <Badge variant="neutral" className="bg-white/90 backdrop-blur-sm text-[9px] border-none shadow-sm uppercase">
                {photo.photo_type === 'before' ? 'Trước' : 
                 photo.photo_type === 'during' ? 'Trong' : 
                 photo.photo_type === 'after' ? 'Sau' : 
                 photo.photo_type === 'issue' ? 'Sự cố' : photo.photo_type}
              </Badge>
            </div>
          </div>
          {photo.caption && (
            <div className="p-3">
              <p className="text-xs text-slate-600 line-clamp-2 italic">"{photo.caption}"</p>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};
